// tanstack
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/$accountId/_user/account/services/')({
  component: () => <Navigate to="/$accountId/account/services/alarms" />,
});
